import Vue from "vue";
import Vuex from "vuex";
import authorisation from "@/modules/authorisation/store/authorisation";
import crudTable from "@/modules/crudTable/store/crudTableStore";
import documentGenerator from "@/modules/documentGenerator/store/documentGenerator";
import error from "@/application/store/error";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const persistedState = createPersistedState({
  paths: ["authorisation", "crudTable"],
});

export default new Vuex.Store({
  plugins: [persistedState],
  modules: {
    authorisation,
    error,
    crudTable,
    documentGenerator,
  },
});
